import { render } from "./AiBlock.vue?vue&type=template&id=7a6ccdf7&scoped=true"
import script from "./AiBlock.vue?vue&type=script&lang=js"
export * from "./AiBlock.vue?vue&type=script&lang=js"

import "./AiBlock.vue?vue&type=style&index=0&id=7a6ccdf7&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7a6ccdf7"]])

export default __exports__